import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import * as _ from "underscore";

import { SessionService } from "./../common/services/session.service";
import { emptyValuePipe } from "./Pipe/empty-value.pipe";
import { EXCEL_COLUMNS } from "./service/constant/shared.constant";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  openedTab = [];
  constructor(
    private ss: SessionService,
    private datePipe: DatePipe,
    private nodataPipe: emptyValuePipe
  ) {}

  getBaseUrl() {
    let url = location.origin + location.pathname + "#";
    return url;
  }

  setOfficeForVirtualView(item) {
    let temp: any = undefined;
    temp = _.find(this.openedTab, function (element) {
      return element.name == item.id;
    });
    if (temp) {
      temp.focus();
    } else {
      let data = {
        id: item.id,
        name: item.name,
        email: item.email,
        landline: item.landline,
        address: item.address,
        city: item.city,
        pincode: item.pincode,
      };
      let url = this.getBaseUrl() + "/admin-dashboard";
      this.ss.setVirtualViewId(data);
      let c = window.open(url, "_blank");
      c.name = item.id;
      this.openedTab.push(c);
      c.focus();
    }
  }

  setAllVirtualView() {
    let temp: any = undefined;
    temp = _.find(this.openedTab, function (element) {
      return element.name == "ALL";
    });
    if (temp) {
      temp.focus();
    } else {
      let data = {
        id: "ALL",
      };
      let url = this.getBaseUrl() + "/viewer-dashboard";
      this.ss.setVirtualViewId(data);
      let c = window.open(url, "_blank");
      c.name = "ALL";
      this.openedTab.push(c);
      c.focus();
    }
  }

  saveExcel(obj, excelConfiguration) {
    this.exportExcel(obj, excelConfiguration);
  }
  exportExcel(data, excelConfiguration) {
    let xlColumnConfig = { wch: 20 };
    let xlSheetCols = EXCEL_COLUMNS.COLUMNS_LENTHS;
    //let customWorkSheet = {"!ref":"A1:Z1600"};
    let customWorkSheet = { "!ref": "A1:Z1600", "!cols": [] };
    excelConfiguration.columnDefination.forEach((element, index) => {
      customWorkSheet[`${xlSheetCols[index]}${1}`] = {};
      customWorkSheet[`${xlSheetCols[index]}${1}`]["v"] = element.displayName;
      customWorkSheet[`${xlSheetCols[index]}${1}`]["t"] = "s";
      customWorkSheet["!cols"].push(xlColumnConfig);
    });
    data.forEach((element, index) => {
      excelConfiguration.columnDefination.forEach((colElement, colIndex) => {
        let cIndex = index + 2;
        customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`] = {};
        if (colElement.isObj) {
          let val = "";
          if (colElement.valueKey) {
            colElement.valueKey.forEach((objEle) => {
              if (element[colElement.obj] && element[colElement.obj][objEle]) {
                val += element[colElement.obj][objEle] + " ";
              }
            });
          }
          customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = val;
          //customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = element[colElement.obj][colElement.valueKey];
        } else {
          let val = "";
          if (colElement.valueKey) {
            colElement.valueKey.forEach((objEle) => {
              val += element[objEle];
              +" ";
            });
          }
          //customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = element[colElement.valueKey];
          customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = val;
        }
        customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["t"] = "s";

        if (colElement.type === "DATE") {
          let c = customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"];
          //c = assign formated date
          // if(c && c != null ){
          //   console.log("c:-",c);

          // }
          c = this.datePipe.transform(c, "dd/MM/yy");
          customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = c;
        }
        if (colElement.type === "NO_DATA") {
          let c = customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"];
          //c = assign formated data
          c = this.nodataPipe.transform(c);
          customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = c;
        }
        if (colElement.type === "CUSTOM_STRING") {
          let c = customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"];
          //c = assign formated custom string
          customWorkSheet[`${xlSheetCols[colIndex]}${cIndex}`]["v"] = c;
        }
      });
    });
    import("xlsx").then((xlsx) => {
      //const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = {
        Sheets: { data: customWorkSheet },
        SheetNames: ["data"],
      };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, excelConfiguration.excelName);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  PaginationPerPage($event) {
    let num = 0;
    if ($event.first == 0) {
      num = 0;
    } else {
      num = $event.first / $event.rows;
    }
    let page = {
      number: num,
      size: $event.rows,
    };
    return page;
  }

  jsonParse(data) {
    return JSON.parse(JSON.stringify(data));
  }

  CalYearRange() {
    let runningYear = new Date().getFullYear();
    return `${runningYear - 100}:${runningYear}`;
  }
}
